module.exports = __webpack_public_path__ + "static/img/6666.d7c4bd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pro/park/6666.png
// module id = YVXR
// module chunks = 0